import ReducerRegistry from '../base/redux/ReducerRegistry';
import { DISMISS_FEEDBACK, FEEDBACK_FAILED, FEEDBACK_REQUESTED, OPEN_SLIDE_PANEL, SET_FEEDBACK_MODAL, SET_SLIDE_STATUS, SET_SLIDE_URL, TOGGLE_SLIDE_PANEL } from './actionTypes';
const IDLE_FEEDBACK = {
    error: '',
    modal: false,
    phase: 'idle',
    startedAt: null
};
const DEFAULT_STATE = {
    feedback: IDLE_FEEDBACK,
    visible: false,
    url: '/pdf-proxy/nihon-ped-surg.jp/wp-content/uploads/2021/11/pdf_test.pdf',
    slideStatus: null,
    hasSlide: false,
    attention: false,
    kind: 'slide',
    score: null,
    feedbackUnread: false
};
ReducerRegistry.register('features/slide-view', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case TOGGLE_SLIDE_PANEL: {
            const nowVisible = !state.visible;
            return {
                ...state,
                visible: nowVisible,
                // 開いたら強調を解除（ユーザーが確認した）
                attention: nowVisible ? false : state.attention,
                // 開いたらAI評価の未読も解除（レポートを確認したとみなす）
                feedbackUnread: nowVisible ? false : state.feedbackUnread
            };
        }
        case SET_SLIDE_URL: {
            const kind = action.kind || 'slide';
            const isFeedback = kind === 'feedback_report';
            return {
                ...state,
                url: action.url,
                hasSlide: true,
                kind,
                score: typeof action.score === 'number' ? action.score : null,
                // 自動では開かない。開いていなければアイコンを強調して気付いてもらう
                visible: state.visible,
                attention: !state.visible,
                // AI評価レポートのみ未読フラグを立てる（通常スライドは対象外）
                feedbackUnread: isFeedback && !state.visible ? true : state.feedbackUnread,
                // 依頼中に評価レポートが届いたら「できました」に進める（ポップアップを出す）。
                feedback: isFeedback && state.feedback.phase === 'running'
                    ? { ...state.feedback, phase: 'done', modal: true, error: '' }
                    : state.feedback
            };
        }
        case OPEN_SLIDE_PANEL:
            return {
                ...state,
                visible: true,
                attention: false,
                feedbackUnread: false
            };
        case FEEDBACK_REQUESTED:
            return {
                ...state,
                feedback: { error: '', modal: true, phase: 'running', startedAt: Date.now() }
            };
        case FEEDBACK_FAILED:
            return {
                ...state,
                feedback: { ...state.feedback, error: String(action.error || ''), modal: true, phase: 'failed' }
            };
        case SET_FEEDBACK_MODAL:
            return {
                ...state,
                feedback: { ...state.feedback, modal: Boolean(action.visible) }
            };
        case DISMISS_FEEDBACK:
            return {
                ...state,
                feedback: IDLE_FEEDBACK
            };
        case SET_SLIDE_STATUS: {
            const isReady = action.status?.state === 'ready';
            return {
                ...state,
                slideStatus: action.status,
                hasSlide: state.hasSlide || isReady,
                // 準備完了(ready)で未オープンなら強調
                attention: isReady && !state.visible ? true : state.attention
            };
        }
        default:
            return state;
    }
});
